import formSchema from '@genfun/core/data/formSchema.json';

const CDN = 'https://genres.nyc3.cdn.digitaloceanspaces.com/claude/create_mode';

const pose = (text, file, formRef, skip, next) => ({ text, img: `${CDN}/pose/${file}.webp`, formRef, skip, next });
const solo = (text, file, idx) => pose(text, file, { stage1: 0 }, { stage_pose_solo: idx }, 'stage_ethnicity_solo');

// formRef / skip are fixed indices into the shared form schema; `next` is where the girl wizard starts.
export const POSE_OPTIONS = [
    solo('Doggy/twerk', 'doggy_twerk', 0),
    solo('Standing Glamur', 'standing_glomour_2', 1),
    solo('SideCurve', 'side_curve', 2),
    solo('Selfie', 'selfie', 3),
    solo('KneesFrog', 'knees_frog', 4),
    solo('BendOverTease', 'bend_over_tease', 5),
    solo('Showing pussy', 'showing_pussy', 6),
    pose('Spread legs', 'spread_legs', { stage1: 1, stage_classic: 1 }, {}, 'stage_ethnicity_spread_legs'),
    pose('Gangbang', 'gang_bang', { stage1: 1, stage_classic: 4 }, {}, 'stage_ethnicity_gangbang'),
    pose('Reverse cowgirl', 'reverse_cow_girl', { stage1: 1, stage_classic: 5 }, {}, 'stage_ethnicity_reverse_cowgirl'),
    pose('Blowjob', 'blow_job', { stage1: 2, stage_bjs: 0 }, {}, 'stage_ethnicity_blowjob'),
    pose('POV cumshot', 'cumshot', { stage1: 2, stage_bjs: 2 }, {}, 'stage_ethnicity_cumshot_pov'),
];

// Keyed by the schema's option text — renaming an option there breaks its image.
const clothes = (file) => `${CDN}/clothes/${file}.webp`;
export const CLOTHES_IMAGES = {
    'Gold chain': clothes('gold_chain'),
    'NUDE': clothes('nude'),
    'School': clothes('school'),
    'Cheerleader': clothes('cheerleader'),
    'Flight attendat': clothes('flight'),
    'Nurse': clothes('nurse'),
    'Police': clothes('police'),
    'Denim shorts': clothes('denim_shorts'),
    'Micro bikini': clothes('micro_bikini'),
    'Kimono': clothes('kimono'),
    'BDSM': clothes('bdsm'),
    'Pink lingerie': clothes('pink_lingerie'),
    'Mini dress': clothes('mini_dress'),
};

const location = (file) => `${CDN}/location/${file}.webp`;
export const LOCATION_IMAGES = {
    'Sofa': location('sofa'),
    'Island': location('island_'),
    'Medium apart': location('abonden_apart'),
    'Church': location('church'),
    'Sauna': location('sauna'),
    'American diner': location('american_diner'),
    'Pirate ship': location('pirate_ship'),
    'Japanese pool': location('japanese_pool'),
    'City View': location('city_view'),
    'Winter': location('winter'),
    'New York street': location('new_york'),
    'Desert': location('desert'),
    'London street': location('london_street'),
    'School': location('school_location'),
    'Great Wall of China': location('great_wall'),
    'Yacht': location('yacht_'),
};

export const CLOTHES_OPTIONS = formSchema.stage_clothes_solo.options;
export const LOCATION_OPTIONS = formSchema.stage_location_solo.options;

export const POSE_PREVIEWS = [POSE_OPTIONS[1].img, POSE_OPTIONS[2].img, POSE_OPTIONS[10].img];
export const CLOTHES_PREVIEWS = [CLOTHES_IMAGES['NUDE'], CLOTHES_IMAGES['Cheerleader'], CLOTHES_IMAGES['Mini dress']];
export const LOCATION_PREVIEWS = [LOCATION_IMAGES['Sofa'], LOCATION_IMAGES['City View'], LOCATION_IMAGES['Sauna']];

const preset = (name, file, values) => ({ name, img: `${CDN}/preset/${file}.webp`, values });
export const GIRL_PRESETS = [
    preset('Insta Bimbo', 'insta_bimbo', { ethnicity: 'scandinavian', girl_type: 'insta', hair: 'blonde', hair_style: 'long', body_type: 'perfect', breast_size: 'medium', age: '20' }),
    preset('Harley Quinn', 'harley', { ethnicity: 'european', girl_type: 'harley_quinn', hair: 'pink', hair_style: 'braids', body_type: 'perfect', breast_size: 'medium', age: '20' }),
    preset('Arab Insta', 'arab', { ethnicity: 'arab', girl_type: 'insta_arab', hair: 'black', hair_style: 'curls', body_type: 'chubby', breast_size: 'large', age: '30' }),
    preset('Tattoo GOT', 'tattoo+got', { ethnicity: 'european', girl_type: 'tatto_got', hair: 'black', hair_style: 'auto', body_type: 'skinny', breast_size: 'small', age: '18' }),
    preset('Cute Nerd', 'cute_nerd', { ethnicity: 'european', girl_type: 'a_nerd', hair: 'brunette', hair_style: 'braids', body_type: 'perfect', breast_size: 'medium', age: '18' }),
    preset('Ginger Insta', 'ginger_insta', { ethnicity: 'european', girl_type: 'insta', hair: 'ginger', hair_style: 'long', body_type: 'perfect', breast_size: 'medium', age: '20' }),
    preset('Slavic Blonde', 'slavic', { ethnicity: 'slavic', girl_type: 'woman', hair: 'blonde', hair_style: 'long', body_type: 'perfect', breast_size: 'large', age: '20' }),
    preset('Asian Insta', 'asian_insta', { ethnicity: 'asian', girl_type: 'asian_insta', hair: 'pink', hair_style: 'curls', body_type: 'perfect', breast_size: 'medium', age: '20' }),
    preset('Asian Tattoo', 'asian_tattoo', { ethnicity: 'asian', girl_type: 'asian_tatoo', hair: 'black', hair_style: 'braids', body_type: 'perfect', breast_size: 'medium', age: '20' }),
];
